import InfoSettingProfilePanel from "./infoSettingProfilePanel.container";

export default InfoSettingProfilePanel;
